import React from 'react'

import { Table, TableCol, TableRow } from '../../../../../../components/pdf/Table'
import Image from '../../../../../../components/pdf/Image'
import Text from '../../../../../../components/pdf/Text'

const Header = ({ headerValues }) => {
  return (
    <Table width="100%" useFontBaseColor>
      <TableRow useFontBaseColor>
        <TableCol rowSpan={7} useFontBaseColor>
          <Image src="/pdfs/itau/grupo-rc4-logo.jpg" style={{ margin: 'auto' }} width={150} ignoreFixedSize />
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text bold>Tipo de Documento:</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Text bold>Código: ANEXO 02</Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text>{headerValues.tipo}</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Text>AR/MM-001/2023</Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text bold>Título:</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Text bold>Data de Emissão:</Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text>{headerValues.titulo}</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Text>{headerValues.dataEmissao}</Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text bold>Emitente:</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Text bold>No Revisão/Data de Revisão:</Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text>{headerValues.emitente}</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Text>REV-0</Text>
        </TableCol>
      </TableRow>
      <TableRow bgColor="#000" useFontBaseColor>
        <TableCol colSpan={3} useFontBaseColor>
          <Text bold color="#FFF" align="center">
            PLANILHA DE CÁLCULO DE RISCO - MÉTODO MOSLER
          </Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol colSpan={3} useFontBaseColor>
          <Text bold>{headerValues.local}</Text>
        </TableCol>
      </TableRow>
    </Table>
  )
}

export default Header
